export default __webpack_public_path__ + "static/media/privacy-policy.dbe112fc.md";